/* eslint-disable */
<script>
import CardVue from './Card.vue';
import cardGal from './cardGal.vue';


export default{
    name:"MainPage",
    components: {
    CardVue,
    cardGal,
  },
  data(){
    return{
      label : "Мета фонду",
      label1 : "Цілі Фонду",
      Text: "Фонд створено з метою, здійснення благодійної діяльності в інтересах громадян, суспільства; надання допомоги постраждалим від воєнних дій; надання допомоги тим, хто у скрутному становищі за станом здоров’я та по іншим причинам;надання допомоги дітям-сиротам, дітям з малозабезпечених та неблагополучних сімей, дітям з інвалідністю,внутрішньо переміщеним особам; створення простору для самореалізації дітей та молоді; пропаганди здорового способу життя; фінансування проєктів із підтримки існуючих та створення і будівництва нових майданчиків, дитячих будинків таін.; затверджувати і виконувати благодійні програми.",
      Text1:"Цілями благодійної діяльності Фонду є надання допомоги для сприяння законним інтересам бенефіціарів: особам, які постраждали чи можуть постраждати від збройної агресії, малозабезпеченим, тим хто у скрутному становищі, зокрема, за станом здоров’я та по іншим причинам. Крім того, Фонд активно сприяє соціальній реабілітації постраждалих, допомагаючи їм відновлювати психологічне та емоційне здоров’я через програми підтримки та реабілітаційні заходи. Одним з важливих напрямків діяльності є надання гуманітарної допомоги у вигляді продовольства, медикаментів, одягу та інших необхідних речей."
    }
  }
}
</script>

<template>
  <div>
    <div class="card-container">
      <CardVue :title="label1" :text="Text1" />
      <CardVue :title="label" :text="Text" />
      <cardGal />
    </div>
    <MyFooter />
  </div>
</template>


<style>
.card-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 80px;
}

</style>